import * as React from 'react';
import styled from 'styled-components';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import { themeGet, space, color } from 'styled-system';
import { Button, Box } from '../../components';

type Props = {
  onClickNext?: () => void;
  onClickPrevious?: () => void;
  onClickSave?: () => void;
  onClickPublish?: () => void;
  onClickCancel?: () => void;
  onClickArchive?: () => void;
  onClickApprove?: () => void;
  nextButton?: boolean;
  saveButton?: boolean;
  cancelButton?: boolean;
  archiveButton?: boolean;
  publishButton?: boolean;
  previousButton?: boolean;
  approveButton?: boolean;
  isSubmit?: boolean;
  currentlyLoading?: string;
  publishText?: string;
  saveText?: string;
  loading?: boolean;
};

const FooterTabs = styled.div<StyledSystemProps & { $spaceBetween: boolean }>`
  ${space};
  ${color};
  right: 0;
  bottom: 0;
  left: 60px;
  height: 60px;
  display: flex;
  position: fixed;
  align-items: center;
  flex-direction: row;
  justify-content: ${(props) => (props.$spaceBetween ? 'space-between' : 'flex-end')};
  box-shadow: ${themeGet('boxShadowTop', '#FFF')};
`;

const Footer: React.FC<Props> = (props) => {
  const {
    onClickNext,
    onClickPrevious,
    onClickSave,
    onClickPublish,
    onClickArchive,
    onClickApprove,
    nextButton,
    saveButton,
    publishButton,
    previousButton,
    approveButton,
    isSubmit,
    currentlyLoading,
    onClickCancel,
    saveText,
    cancelButton,
    archiveButton,
    loading,
  } = props;

  const spaceBetween = !!(previousButton || cancelButton || archiveButton);

  return (
    <FooterTabs bg="white" px={3} $spaceBetween={spaceBetween}>
      <Box flexDirection="row">
        {previousButton && <Button onClick={onClickPrevious} type="button" text="Previous" width="220px" bg="coal" />}
        {archiveButton && <Button onClick={onClickArchive} type="button" text="Archive" width="220px" bg="error" />}
        {cancelButton && (
          <Button
            onClick={onClickCancel}
            type="button"
            text="Cancel"
            bg="error"
            width="220px"
            isLoading={loading && currentlyLoading === 'CANCEL'}
          />
        )}
      </Box>
      <Box flexDirection="row">
        {approveButton && (
          <Button
            onClick={onClickApprove}
            type="button"
            text="Approve"
            bg="success"
            width="220px"
            ml={4}
            isLoading={loading && currentlyLoading === 'APPROVE'}
          />
        )}
        {saveButton && (
          <Button
            onClick={onClickSave}
            type={isSubmit ? 'submit' : 'button'}
            text={saveText || 'Save as Draft'}
            width="220px"
            ml={4}
            isLoading={loading && currentlyLoading === 'SAVE'}
          />
        )}
        {publishButton && (
          <Button
            onClick={onClickPublish}
            type="button"
            text="Publish"
            bg="success"
            width="220px"
            ml={4}
            isLoading={loading && currentlyLoading === 'PUBLISH'}
          />
        )}
        {nextButton && (
          <Button
            onClick={onClickNext}
            type={isSubmit ? 'submit' : 'button'}
            text="Next"
            bg="charcoalGrey"
            ml={4}
            width="220px"
            isLoading={loading && currentlyLoading === 'NEXT'}
          />
        )}
      </Box>
    </FooterTabs>
  );
};

Footer.defaultProps = {
  nextButton: true,
  saveButton: true,
  publishButton: false,
  previousButton: true,
  approveButton: false,
};

export default Footer;



// WEBPACK FOOTER //
// ./src/containers/events/Footer.tsx